import { Header } from 'palette/Typography';
import { useConfig } from '@common/Hooks/useConfig';
import { useTranslation } from '@common/Hooks/useTranslation';
import { getTranslatedPropertyFromContext } from '@helpers/translationContext';
import '../styles/SubCatModal.scss';

function SubCatModal({ subcategories }) {
    const config = useConfig();
    const translate = useTranslation();

    const { store, language } = config;
    const subcategoryName = getTranslatedPropertyFromContext(subcategories, 'name', config);
    const modalTitle = `${subcategoryName} ${translate('listing.subcategories.category').toLowerCase()}`;

    return (
        <ul className="subcat-modal__list">
            <li>
                <Header
                    level="2"
                    weight="bold"
                >
                    { modalTitle }
                </Header>
            </li>
            {
                subcategories.children.map(subcat => (
                    <li
                        key={subcat.id}
                        className="subcat-modal__list-item"
                    >
                        <a
                            className="subcat-modal__link"
                            href={`/${store}/${language}${subcat.url}`}
                        >
                            {getTranslatedPropertyFromContext(subcat, 'name', config)}
                            <i className="subcat-modal__product-count">
                                (
                                {subcat.productCount}
                                )
                            </i>
                        </a>
                    </li>
                ))
            }
        </ul>
    );
}

export default SubCatModal;
